import React from "react";

const Error = props => (
  <span className={"error " + props.className}>{props.children}</span>
);

export default Error;
